<template>
  <path d="M15.8333 2.5L19.1667 6.66667H16.6667V16.6667H15V6.66667H12.5L15.8333 2.5ZM11.6667 15V16.6667H2.5V15H11.6667ZM11.6667 9.16667V10.8333H2.5V9.16667H11.6667ZM10 3.33333V5H2.5V3.33333H10Z"/>
</template>

<script>
export default {
  name: "IconSort"
}
</script>

<style scoped>

</style>